import { ImMessage } from "@whatslly/types/tuvis-messaging/TuvisMessagingMessages";

export const SW_COMMANDS_PREFIX = "tuvis-messaging";

export const SWCommands = {
  ABORT_TRANSACTION: `${SW_COMMANDS_PREFIX}:abort-transaction`,
  RESPONSE: `${SW_COMMANDS_PREFIX}:web-script-response`,
  ERROR: `${SW_COMMANDS_PREFIX}:web-script-error`,
  GET_CHAT: `${SW_COMMANDS_PREFIX}:get-chat`,
  OPEN_CHAT: `${SW_COMMANDS_PREFIX}:open-chat`,
} as const;

export type SWCommandsKeys = keyof typeof SWCommands;

export type SWCommandsTypes = {
  [SWCommands.ABORT_TRANSACTION]: never;
  [SWCommands.RESPONSE]: never;
  [SWCommands.ERROR]: never;
  [SWCommands.GET_CHAT]: (msg: ImMessage) => { _id: string | undefined; displayName: string | undefined; lang: string };
  [SWCommands.OPEN_CHAT]: (chatId: string) => any;
};
